if (!customElements.get('how-it-works-slider')) {
  class HowItWorksSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-slider]');
      this.bindVideos();
      if (!this.track || this.track.children.length < 2) return;

      this.mql = window.matchMedia('(max-width: 991px)');
      this.onChange = () => this.sync();
      this.onWinResize = () => {
        if (this.mql.matches) this.equalize();
      };
      this.mql.addEventListener('change', this.onChange);
      window.addEventListener('resize', this.onWinResize, { passive: true });
      this.sync();
    }

    disconnectedCallback() {
      this.mql?.removeEventListener('change', this.onChange);
      window.removeEventListener('resize', this.onWinResize);
      clearTimeout(this.equalizeTimer);
      this.destroy();
    }

    bindVideos() {
      this.querySelectorAll('.how-it-works__media video').forEach((video) => {
        const ready = () => video.classList.add('is-ready');
        if (video.readyState >= 2) ready();
        else video.addEventListener('loadeddata', ready, { once: true });
      });
    }

    sync() {
      if (this.mql.matches) {
        this.init();
        this.equalize();
      } else {
        this.destroy();
      }
    }

    scheduleEqualize() {
      clearTimeout(this.equalizeTimer);
      this.equalizeTimer = setTimeout(() => this.equalize(), 50);
    }

    equalize() {
      if (!this.flickity || !this.mql.matches) return;

      const cells = this.flickity.cells?.map((c) => c.element) || [];
      if (!cells.length) return;

      this.track.classList.add('is-equalizing');
      cells.forEach((el) => {
        el.style.height = 'auto';
      });

      const max = Math.max(0, ...cells.map((el) => el.offsetHeight));
      this.track.classList.remove('is-equalizing');

      if (!max) return;

      this.track.style.setProperty('--how-it-works-slide-height', `${max}px`);
      this.track.querySelectorAll('.how-it-works__step').forEach((el) => {
        el.style.height = `${max}px`;
      });
      this.flickity.resize();
    }

    init() {
      if (this.flickity) return;
      if (typeof Flickity === 'undefined') {
        requestAnimationFrame(() => this.init());
        return;
      }

      this.flickity = new Flickity(this.track, {
        accessibility: false,
        rightToLeft: theme.config?.rtl || false,
        prevNextButtons: false,
        pageDots: true,
        wrapAround: true,
        draggable: true,
        cellAlign: 'center',
        contain: false,
        adaptiveHeight: false,
        dragThreshold: 20,
        on: {
          ready: () => this.scheduleEqualize()
        }
      });

      if (document.fonts?.ready) {
        document.fonts.ready.then(() => this.scheduleEqualize());
      }
    }

    destroy() {
      clearTimeout(this.equalizeTimer);
      if (!this.flickity) return;
      this.track.style.removeProperty('--how-it-works-slide-height');
      this.track.querySelectorAll('.how-it-works__step').forEach((el) => {
        el.style.height = '';
      });
      this.flickity.destroy();
      this.flickity = null;
    }
  }

  customElements.define('how-it-works-slider', HowItWorksSlider);
}
